import { render, staticRenderFns } from "./MNTemplate.vue?vue&type=template&id=779ef9a0&"
import script from "./MNTemplate.vue?vue&type=script&lang=ts&"
export * from "./MNTemplate.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports